<template>
  <TopBarShell mobile-header class="content-owner-top-bar p-0 sm:pt-0 sm:pb-2 sm:px-0" data-testid="content-owner-top-bar">
    <template #actions>
      <div v-if="isImage" class="hidden sm:contents">
        <OcrSelectionToolbar :show-processing="ocrEnabled && ocrFeatureEnabled" :show-upsell="!ocrEnabled" />
      </div>

      <button
        v-if="isImage && !isGif"
        class="content-owner-top-bar__icon-btn"
        title="Annotate"
        aria-label="Annotate"
        :disabled="isEditProcessing"
        data-testid="viewer-topbar-annotate"
        @click="!isEditProcessing ? annotateAction() : undefined"
      >
        <Icon name="general.pencil" size="base" />
      </button>

      <TopBarActions mobile-overflow :mobile-menu-items="ocrMobileMenuItems" />
      <OwnerViewerAppControls />
    </template>
  </TopBarShell>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { Icon } from '@/storybook';

import TopBarShell from '../../shared/TopBarShell.vue';
import TopBarActions from '../../shared/TopBarActions.vue';
import OwnerViewerAppControls from '../../shared/OwnerViewerAppControls.vue';
import OcrSelectionToolbar from '../../shared/OcrSelectionToolbar.vue';

import { useViewerItemStore, ItemType } from '@/modules/viewer/store/useViewerItemStore';
import { useItemActions } from '@/modules/viewer/composables/useItemActions';
import { useFeatures } from '@/composables/useFeatures';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';
import { useMobileDetection } from '@/composables/useMobileDetection';
import { useOcrActions } from '@/modules/viewer/composables/useOcrActions';

const viewerItemStore = useViewerItemStore();
const { isEditProcessing, isGif, type } = storeToRefs(viewerItemStore);
const { annotateAction } = useItemActions();
const { getItemFeature } = useFeatures();
const ocrFeatureEnabled = getItemFeature('image-ocr-enabled', false);
const ocrEnabled = computed(() => useEntitlementsStore().can('ocr'));
const { isMobile } = useMobileDetection();
const { mobileMenuItems } = useOcrActions();

const isImage = computed(() => type.value === ItemType.IMAGE);
const ocrMobileMenuItems = computed(() =>
  isImage.value && isMobile.value
    ? mobileMenuItems({
        showProcessing: ocrEnabled.value && ocrFeatureEnabled.value,
        showUpsell: !ocrEnabled.value,
      })
    : []
);
</script>

<style scoped>
.content-owner-top-bar__icon-btn {
  @apply p-2 rounded-md text-zinc-600 dark:text-zinc-400 hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
